import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { ExternalLink, Sparkles } from "lucide-react";

export default function Resources() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/affiliates").then((r) => setItems(r.data)).catch(() => setItems([])).finally(() => setLoading(false));
  }, []);

  return (
    <div className="fade-in">
      <header className="mb-10">
        <div className="text-xs uppercase tracking-[0.2em] text-primary/80 font-medium mb-3">Trusted Christian Resources</div>
        <h1 className="font-serif text-4xl sm:text-5xl text-stone-900">Resources we recommend.</h1>
        <p className="mt-4 text-lg text-stone-700 max-w-2xl leading-relaxed">
          A curated list of ministries, tools, and communities to encourage your walk. Some links may be sponsored — we only recommend what we believe honors Scripture.
        </p>
      </header>

      {loading ? (
        <div className="text-stone-500" data-testid="resources-loading">Loading resources…</div>
      ) : items.length === 0 ? (
        <div className="rounded-md border border-dashed border-stone-300 bg-white p-12 text-center" data-testid="resources-empty">
          <Sparkles className="h-10 w-10 text-stone-400 mx-auto mb-3" strokeWidth={1.5} />
          <h3 className="font-serif text-2xl text-stone-900">Coming soon</h3>
          <p className="mt-2 text-stone-600 max-w-md mx-auto">We're curating a list of trusted Christian ministries and resources. Check back soon.</p>
        </div>
      ) : (
        <div className="grid gap-6 sm:grid-cols-2" data-testid="resources-grid">
          {items.map((a) => (
            <a
              key={a.id}
              href={a.url}
              target="_blank"
              rel="noopener sponsored noreferrer"
              data-testid={`resource-${a.id}`}
              className="group relative flex overflow-hidden rounded-md border border-stone-200 bg-white transition-all hover:-translate-y-1 hover:border-primary min-h-[180px]"
            >
              {a.image_url && (
                <div className="relative w-48 shrink-0 overflow-hidden">
                  <img src={a.image_url} alt="" className="h-full w-full object-cover transition-transform group-hover:scale-105" />
                  <div className="absolute inset-0 bg-gradient-to-r from-stone-900/40 to-transparent" />
                </div>
              )}
              <div className="flex-1 p-6">
                <div className="font-serif text-2xl text-stone-900 leading-tight">{a.title}</div>
                <p className="mt-2 text-stone-600 leading-relaxed line-clamp-3">{a.description}</p>
                <div className="mt-4 inline-flex items-center gap-1 text-sm font-medium text-primary">
                  Visit resource <ExternalLink className="h-3.5 w-3.5" strokeWidth={1.5} />
                </div>
              </div>
            </a>
          ))}
        </div>
      )}
    </div>
  );
}
